// import * as resultOfConsiderType from './resultOfConsiderType'
// import useResultOfConsider from './useResultOfConsider'
import MyAccordion from '../../../../../control/accordion/accordion'
import RichTextEditor from '../../../../../control/richTextEditor/richTextEditor'
import { Grid, makeStyles } from '@material-ui/core'
import { Form } from 'react-final-form'
import arrayMutators from 'final-form-arrays'
import { FieldArray } from 'react-final-form-arrays'
import useTranslate from '../../../../../i18n/useTranslate'
import PageAction from '../pageAction'
import useSnackbarAction from '../../../../../stores/snackbar/snackbarAction'
import { GetProjectResultType } from '../../../../../services/web/types/responseWebServiceTypes'
import useResultOfConsiderPrevious from './useResultOfConsiderPrevious'
import { approveStatusREC1, approveStatusREC2 } from '../../../../../constants/approveStatus'
//View
export type ResultOfConsiderPreviousViewType = ReturnType<typeof useResultOfConsiderPrevious> &
    ResultOfConsiderPreviousType
const ResultOfConsiderView: React.FC<ResultOfConsiderPreviousViewType> = (props) => {
    const {
        initialValues,
        approveStatus,
        initialComment,
        initialRichTextEditor,
        // documentInfoList,
        initialRichRemark,
        // onClickCancel,
        isViewMode,
        isFlowApproveWithComment = false,
    } = props
    const translate = useTranslate()
    const snackbarAction = useSnackbarAction()

    // const isShowCommentRemarkList = initialValues?.commentRemarkList !== null

    const isShowComment =
        approveStatus &&
        approveStatus?.id !== approveStatusREC1.approve &&
        approveStatus?.id !== approveStatusREC2.approve &&
        approveStatus?.id !== approveStatusREC1.approveForContiueResearch &&
        approveStatus?.id !== approveStatusREC2.approveForContiueResearch &&
        approveStatus?.id !== approveStatusREC1.acknowledgeAndDonotTakeAnyaAction &&
        approveStatus?.id !== approveStatusREC2.acknowledgeAndDonotTakeAnyaAction //ผลการพิจารณาเป็นไม่ใช่อนุมัติและไม่ใช่อนุมัติให้ดำเนินการวิจัยต่อเนื่อง จะโชว์คอมเม้นเป็นหัวข้อ ถ้าเป็นอนุมัติและ อนุมัติให้ดำเนินการวิจัยต่อเนื่องจะโชว์แค่ผลไม่โชว์คอมเม้น

    // const isStatusComplete = projectData && projectData?.projectStatusInfo?.value === 2

    const renderResearcherView = (name: string, index: number) => {
        return (
            <>
                <Grid item xs={12} md={12} lg={12}>
                    <RichTextEditor
                        name={`${name}.consideration`}
                        initialRichTextEditor={initialRichTextEditor[index]}
                        disabled={isViewMode}
                        isHideToolbar={true}
                        label={
                            initialComment[index]?.no
                                ? `${initialComment[index]?.no}. ${initialComment[index]?.topic}`
                                : translate.get('LABEL.SUGGESTION_NOTICE')
                        }
                    />
                </Grid>
            </>
        )
    }

    return (
        <Form
            onSubmit={() => {}}
            initialValues={{ ...initialValues, commentDirector: initialComment }}
            keepDirtyOnReinitialize={true}
            mutators={{
                ...arrayMutators,
            }}
        >
            {(props) => {
                const { form, handleSubmit, invalid, errors } = props

                return (
                    <>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <MyAccordion title={translate.get('LABEL.RESOLUTION')}>
                                    <Grid container item justify="flex-start" spacing={2}>
                                        <Grid item xs={12} md={12} lg={12}>
                                            <Grid item xs={12} md={12} lg={12}>
                                                <RichTextEditor
                                                    name="remark"
                                                    initialRichTextEditor={initialRichRemark}
                                                    disabled={isViewMode}
                                                    isHideToolbar={isViewMode}
                                                    // label={translate.get('LABEL.ETHIC_REVIEW_OUTCOME')}
                                                    maxLength={2000}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </MyAccordion>
                            </Grid>
                            <Grid item xs={12}>
                                <MyAccordion title={translate.get('LABEL.NOTIFY_REVIEW_OUTCOME')}>
                                    <Grid container item justify="flex-start" spacing={2}>
                                        <Grid item xs={12} md={12} lg={12}>
                                            {translate.get('LABEL.ETHIC_REVIEW_OUTCOME')} :{' '}
                                            {approveStatus?.id === approveStatusREC1.approveWithComment ||
                                            approveStatus?.id === approveStatusREC2.approveWithComment
                                                ? translate.get('LABEL.APPROVE')
                                                : translate.languageStore.currentLanguage === translate.languageKey.th
                                                ? approveStatus?.nameTH
                                                : approveStatus?.nameEN}
                                        </Grid>

                                        {isShowComment && (
                                            <FieldArray name="commentDirector">
                                                {({ fields }) => {
                                                    return fields?.map((name, index) =>
                                                        renderResearcherView(name, index),
                                                    )
                                                }}
                                            </FieldArray>
                                        )}
                                    </Grid>
                                </MyAccordion>
                            </Grid>

                            {/* <Grid item xs={12}>
                                <MyAccordion title={translate.get('LABEL.REMARK')}>
                                    <Grid container item justify="flex-start" spacing={2}>
                                        {!isResearcherView ? (
                                            <Grid item xs={12} md={12} lg={12}>
                                                {isShowCommentRemarkList && (
                                                    <Grid item xs={12} md={12} lg={12}>
                                                        <MyTextfield
                                                            name="commentRemarkList"
                                                            materialInputProps={{
                                                                disabled: true,
                                                                label: '',
                                                                size: 'small',
                                                                rows: 5,
                                                                multiline: true,
                                                            }}
                                                            // required
                                                        />
                                                    </Grid>
                                                )}

                                                <Grid item xs={12} md={12} lg={12}>
                                                    <RichTextEditor
                                                        name="remark"
                                                        initialRichTextEditor={initialRichRemark}
                                                        disabled={isViewMode}
                                                        isHideToolbar={isViewMode}
                                                        // label={translate.get('LABEL.ETHIC_REVIEW_OUTCOME')}
                                                        maxLength={2000}
                                                    />
                                                </Grid>
                                            </Grid>
                                        ) : (
                                            <Grid item xs={12} md={12} lg={12}>
                                                <RichTextEditor
                                                    name="remark"
                                                    initialRichTextEditor={initialRichRemark}
                                                    disabled={true} //{isViewMode}
                                                    isHideToolbar={true}
                                                    // label={translate.get('LABEL.ETHIC_REVIEW_OUTCOME')}
                                                    maxLength={2000}
                                                />
                                            </Grid>
                                        )}
                                    </Grid>
                                </MyAccordion>
                            </Grid> */}
                        </Grid>
                        {!isViewMode && (
                            <Grid item xs={12}>
                                <PageAction
                                    onClickClose={() => {
                                        // onClickCancel(dirty)
                                    }}
                                    onClickSave={() => {
                                        form.change('submitType', 'save')
                                        handleSubmit()
                                        invalid &&
                                            errors &&
                                            snackbarAction.openSnackbar({
                                                message: translate.get('MESSAGE.M012'),
                                                type: 'error',
                                            })
                                    }}
                                    onClickSaveDraft={() => {
                                        form.change('submitType', 'draft')
                                        handleSubmit()
                                    }}
                                />
                            </Grid>
                        )}
                        {/* <Dialog onRef={onRefDialog} {...configDialog} /> */}
                        {/* <FormSpy subscription={{ dirty: true, values: true }} onChange={handleDirtyChange} /> */}
                    </>
                )
            }}
        </Form>
    )
}

//Controller
export type ResultOfConsiderPreviousType = {
    projectID: number
    submittedID: number
    callbackSaveComplete?: (resStatus: number, isDraft: boolean) => void
    isHideDocumentCertificate?: boolean
    projectData2?: GetProjectResultType | null
}
const ResultConsiderPrevious: React.FC<ResultOfConsiderPreviousType> = (props) => {
    const useResultOfConsiderPreviousModel = useResultOfConsiderPrevious(props)
    return <ResultOfConsiderView {...useResultOfConsiderPreviousModel} {...props} />
}
const useStyles = makeStyles((theme) => ({
    spacingButton: {
        marginBottom: '10px',
    },
    paper: {
        width: '100%',
        height: 128,
        padding: 20,
    },
    titleFont: {
        color: '#BDBDBD',
    },
    contentFont: {
        fontWeight: 'bold',
    },
}))

export default ResultConsiderPrevious
